export default __webpack_public_path__ + "static/media/buyers.e5801a80.jpg";